import React, { createClass, PropTypes } from 'react';
import { call, cond, equals, always, T, prop, propOr } from 'ramda';
import FileLink from './file-link';
import StorageLink from './storage-link';

const ExternalLinksContainer = createClass({
  propTypes: {
    MMReducer: PropTypes.object,
    onFileLinkSubmit: PropTypes.func,
    onCancel: PropTypes.func,
  },

  getInitialState() {
    return {
      fileType: '',
      storageType: '',
      storageUrl: '',
      fileTypeChecked: false,
      fileTypeError: false,
      checkingFileType: false,
    };
  },

  // video onError does NOT work with our version of react.
  // once updated, this should fire.
  // https://github.com/facebook/react/commit/e1c2c42c2461ae2007000196571be20b8e597171
  // update submit button to check for video
  onFileTypeError() {
    this.setState({
      fileTypeError: true,
      fileTypeChecked: true,
    });
  },

  onFileTypeCheckedSuccess() {
    this.setState({
      fileTypeError: false,
      fileTypeChecked: true,
    });
    this.submitFile();
  },

  submitFile() {
    if (this.props.MMReducer.showFileLink) {
      // const fileExtension = call(cond([
      //   [equals('image/jpeg'), always('jpeg')],
      //   [equals('video/mp4'), always('mp4')],
      //   [equals('application/pdf'), always('pdf')],
      //   [equals('application/vnd.ms-powerpoint'), always('application/vnd.ms-powerpoint')],
      //   [T, always('')],
      // ]), this.state.fileType);
      const file = {
        url: this.state.url,
        fileType: 'image/jpeg', // this.state.fileType fix this for video
        fileName: `${this.state.name}.jpeg`, // `${this.state.name}.${fileExtension}` for video later
      };
      this.clearState();
      this.props.onFileLinkSubmit(file);
    }
    if (this.props.MMReducer.showStorageLink) {
      const file = {
        url: this.state.url,
        fileType: 'CloudDrive',
        fileName: this.state.name,
        storageProvider: equals(this.state.storageProvider, 'Other') ? this.state.otherStorageProvider : this.state.storageProvider,
        username: prop('username', this.state),
        password: prop('password', this.state),
      };
      this.clearState();
      this.props.onFileLinkSubmit(file);
    }
  },

  clearState() {
    this.setState({
      url: '',
      name: '',
      fileType: '',
      storageType: '',
      storageUrl: '',
      fileTypeChecked: false,
      fileTypeError: false,
      checkingFileType: false,
      storageProvider: '',
    });
  },
  render() {
    const {
      MMReducer,
      onCancel,
    } = this.props;

    // const getFileTypeFromUrl = (url, callback) => {
    //   const xhr = new XMLHttpRequest();
    //   xhr.open('HEAD', url, true);
    //   xhr.onreadystatechange = () => {
    //     callback(xhr.getResponseHeader('Content-Type'));
    //     // xhr.getResponseHeader('Content-Length') this is for file size but is unstable
    //   };
    //   xhr.send();
    // };

    const generateErrorText = (errorType) => call(cond([
      [equals('fileTypeError'), () => {
        return (
          <div style={{ textAlign: 'center' }}>
            <h5 style={{ color: 'red' }}>
              There was a problem with the image URL.
              Please make sure the URL is public and is an image.
            </h5>
          </div>
        );
      }],
      [equals('duplicateUrlError'), () => {
        return (
          <div style={{ textAlign: 'center' }}>
            <h5 style={{ color: 'red' }}>
              This URL has already been uploaded.
              Please enter a different one.
            </h5>
          </div>
        );
      }],
      [equals('missingHttp'), () => {
        return (
          <div style={{ textAlign: 'center' }}>
            <h5 style={{ color: 'red' }}>
              This URL is missing http:// or https://.
              Please double check the link.
            </h5>
          </div>
        );
      }],
      [T, () => <span/>],
    ]), errorType);

    const sharedProps = {
      onCancel,
      clearState: this.clearState,
      state: this.state,
      submitFile: this.submitFile,
      setState: (update) => this.setState(update),
      onFileTypeCheckedSuccess: this.onFileTypeCheckedSuccess,
      onFileTypeError: this.onFileTypeError,
      generateErrorText,
      existingUrls: (this.props.MMReducer.media || []).map(item => item.url),
    };

    return (
      <div>
        {
          MMReducer.showFileLink ?
            <FileLink
              {...sharedProps}
            /> : <span/>
        }
        {
          MMReducer.showStorageLink ?
            <div>
              <StorageLink
                {...sharedProps}
              />
            </div> : <span/>
        }
      </div>
    );
  },
});

export default ExternalLinksContainer;



// WEBPACK FOOTER //
// ./src/app/components/marketing-materials/title-bar/external-links/external-links-container.jsx